import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import WizardPage from "@/pages/WizardPage";
import ProfilePage from "@/pages/ProfilePage";
import PlanPage from "@/pages/PlanPage";

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WizardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/plan/:planId" element={<PlanPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
